import React, { useMemo } from 'react';
import './StokOzetKart.css';

export function computeStokOzet(parcalar) {
  const list = Array.isArray(parcalar) ? parcalar : [];
  return {
    cesit: list.length,
    ozToplam: list.reduce((sum, p) => sum + (Number(p.ozAdet) || 0), 0),
    konsinyeToplam: list.reduce((sum, p) => sum + (Number(p.konsinyeAdet) || 0), 0),
    toplamAdet: list.reduce((sum, p) => sum + (Number(p.adet) || 0), 0),
  };
}

const StokOzetKart = ({ parcalar, className = '' }) => {
  const ozet = useMemo(() => computeStokOzet(parcalar), [parcalar]);

  return (
    <div className={`stok-ozet-kart${className ? ` ${className}` : ''}`} aria-label="Stok özeti">
      <div className="stok-ozet-kart__item">
        <span className="stok-ozet-kart__label">Farklı parça</span>
        <span className="stok-ozet-kart__value">{ozet.cesit}</span>
      </div>
      <div className="stok-ozet-kart__item stok-ozet-kart__item--oz">
        <span className="stok-ozet-kart__label">Toplam öz stok</span>
        <span className="stok-ozet-kart__value">{ozet.ozToplam}</span>
      </div>
      <div className="stok-ozet-kart__item stok-ozet-kart__item--konsinye">
        <span className="stok-ozet-kart__label">Toplam konsinye</span>
        <span className="stok-ozet-kart__value">{ozet.konsinyeToplam}</span>
      </div>
      <div className="stok-ozet-kart__item stok-ozet-kart__item--toplam">
        <span className="stok-ozet-kart__label">Toplam parça</span>
        <span className="stok-ozet-kart__value">{ozet.toplamAdet}</span>
      </div>
    </div>
  );
};

export default StokOzetKart;
